import {
  GOOGLE_ADS_CAMPAIGN_STATUS,
  GoogleAdsCampaignConnectionStatus,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Google Ads',
  search: {
    placeholder: 'Pesquisar por ID, Nome ou Empresa',
  },
  filters: {
    connection_statuses: {
      placeholder: 'Estado da ligação',
      options: {
        [GoogleAdsCampaignConnectionStatus.Connected]: 'Ligado',
        [GoogleAdsCampaignConnectionStatus.NotConnected]: 'Não ligado',
      },
    },
  },
  columns: {
    name: 'Nome',
    company: 'Empresa',
    connected: 'Ligado',
    action: 'Ação',
    details: 'Detalhes',
    address: 'Morada',
    status: 'Estado',
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Não especificado',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Ativo',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Pausado',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Desconhecido',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Removido',
  },
};
